import React, { useState } from 'react';
import { Button, Modal } from '@bedrock/components';
import { ChevronRight, ShareSquare } from '@bedrock/icons-react';
import UploadHeatingBoostModal from "@mpc/common/src/features/UploadHeatingBoostModal";
import { demandQueryBoostEffectData, outsourceDemandQueryBoostEffectData } from 'services/api';
import { $sType } from '#utils';
import contentMarketingLogo from '@mpc/common/src/images/contentMarketingLogo.svg'

type Props = {
    detail?: any,
    className?: string,
    style?: React.CSSProperties,
}

const Index = (props: Props) => {
    const { detail, className, style } = props
    const [value, setValue] = useState([])
    const [visible, setVisible] = useState(false)
    const getApi = (params) => {
        if ($sType === 'inner') {
            return demandQueryBoostEffectData({ ...params })
        } else {
            return outsourceDemandQueryBoostEffectData({ ...params })
        }
    }
    const handleViewBoost = () => {
        setVisible(true)
        getApi({ demand_id: detail?.id }).then((result: any) => {
            if (result?.code === 1) {
                const boostTableList = result?.data?.map((item: any) => {
                    return {
                        ...item,
                        boost_cost: {
                            value: item?.boost_cost,
                            currency: detail?.quote_currency
                        }
                    }
                })
                setValue(boostTableList)
            }
        })
    }
    return (
        <div className={className}>
            <Button
                style={{ textAlign: 'left', marginTop: '5px', ...style }}
                type='checked'
                suffix={<ShareSquare />}
                onClick={handleViewBoost}
                icon={<img src={contentMarketingLogo} className='m-r-4' />}
            >
                查看加热助推效果
            </Button>

            <Modal
                footer={<div></div>}
                onCancel={() => { setVisible(false) }}
                title='上传加热助推效果'
                visible={visible}
                maskClosable={false}
                width={1000}
            >
                <UploadHeatingBoostModal value={value} view={true} />
            </Modal>
        </div>
    )
}

export default Index;